module.exports = __webpack_public_path__ + "img/img16.7a5d67df.png";